import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCalendarAlertIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M16.9998 3c0-.5523-.4478-1-1-1-.5523 0-1 .4477-1 1v1H8.9863V3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H5C3.3432 4 2 5.3431 2 7v12c0 1.6569 1.3432 3 3 3h10.4738c.5522 0 1-.4477 1-1s-.4478-1-1-1H5c-.5523 0-1-.4477-1-1v-7h16v1.0668c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-1.6569-1.3431-3-3-3h-2.0002V3ZM20 10V7c0-.5523-.4477-1-1-1h-2.0002v1c0 .5523-.4478 1-1 1-.5523 0-1-.4477-1-1V6H8.9863v1c0 .5523-.4477 1-1 1s-1-.4477-1-1V6H5c-.5523 0-1 .4477-1 1v3h16Z" clipRule="evenodd"/>
    <path fill="currentColor" d="M21 19c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1s1 .4477 1 1v2Z"/>
    <rect width="2" height="2" x="21" y="23" fill="currentColor" rx="1" transform="rotate(-180 21 23)"/>
  </SvgIcon>
}

export default LineCalendarAlertIcon
